import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sap-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.css']
})
export class LoginLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/login-layout/login-layout.component.ts